// import { normalizePost } from '../../utils/normalize'
import { componentIs } from '../../plugins/filters'

export default {
  functional: true,
  name: 'GridCell',
  props: {
    clientRoute: {
      type: String
    },
    column: {
      required: true,
      type: Object
    },
    row: {
      type: Object,
      required: true
    },
    id: {
      type: [String, Number],
      required: true
    },
    value: {
      required: true,
      default: () => ''
    },
    hasPopover: {
      type: Boolean,
      default: () => false
    },
    resource: {
      type: String,
      default: () => this.$route.meta.resource
    },
    trashed: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: () => false
    }
  },
  /*
  data () {
    return {
      editOpened: false,
      valueModel: this.value,
      editing: false
    }
  },
  methods: {
    handleEditMode () {
      this.editing = true
    },
    async handleSave () {
      try {
        const model = normalizePost({
          ...this.row,
          ...{
            [this.column.field]: this.valueModel
          }
        })
        await this.$store.dispatch(`${this.resource}/apiUpdate`, {
          id: this.row.id,
          model: model,
          client: this.$axios
        })
        this.$q.notify({
          type: 'positive',
          message: 'Saved!'
        })
      } catch (e) {
        this.$q.notify({
          type: 'negative',
          message: `Could not save ${e.message}`,
          timeout: 5500,
          button: {
            label: 'Close'
          }
        })
      }
    },
    handleCopy () {
      this.$q.notify({
        type: 'positive',
        message: `Copied to clipboard: ${this.value}`,
        icon: 'content_copy',
        timeout: 3500,
        button: {
          label: 'Close'
        }
      })
    },
    handleAdd () {
      this.$q.notify({
        type: 'negative',
        message: `TODO: Grid Cell > handleAdd`,
        timeout: 5500,
        button: {
          label: 'Close'
        }
      })
    },
    handleRemove () {
      this.$q.notify({
        type: 'negative',
        message: `TODO: Grid Cell > handleRemove`,
        timeout: 5500,
        button: {
          label: 'Close'
        }
      })
    },
    handleInput (field, value) {
      this.valueModel = value
    }
  },
  */
  render (createElement, context) {
    return createElement(
      componentIs(context.props.column),
      {
        props: context.props
      },
      context.children
    )
  }
}
